import rq from '@/request'

const resource = 'profile'
const get = () => rq.get(`${resource}`)
const store = data => rq.post(`${resource}`, data)

export default {
  get,
  store
}



// WEBPACK FOOTER //
// ./src/api/profile.js